import React, { useState } from 'react';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import { Col, Row } from 'react-bootstrap';

import '../CSS/Header.css'


const Header = () => {
  const { user, signOut } = useAuthenticator();

  const header =
    <Container className='header-class'>
      <Row>
        <Col xs={12} xl={1}>
          <Navbar.Brand className='Header_Brand' href="/">StockRisk </Navbar.Brand>
        </Col>
        <Col xs={12} xl={4}>
          <Navbar.Brand className='Header_Brand' href="/"> Stock Portfolio Analytics tools</Navbar.Brand>
        </Col>
        <Col xs={12} md={3}>
          <Nav className="me-auto">
            <Nav.Link href="About" className='Header_navbar'>About</Nav.Link>
            <Nav.Link href="Disclaimer" className='Header_navbar'>Disclaimer</Nav.Link>
          </Nav>
        </Col>
        <Col xs={12} md={3} className="ms-md-auto text-md-end">
          <Row className='d-none'>
            <Col>
              <Navbar.Text>
                {user ? (
                  <p className='headerText'>Logged in using: {user.attributes.email}</p>
                ) : <p className='headerText'>Not logged in!</p>}
              </Navbar.Text>
            </Col>
            <Col>
              <Button variant="outline-light" onClick={signOut} disabled={!user}>Sign out</Button>
              <Button variant="outline-light" href='LogIn' disabled={user}>Log in</Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>

  return header
};

export default Header;